import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import apiProducts from 'api/products';
import BasicTable from 'components/layout/tables/BasicTable';
import IProduct from 'api/interfaces/products/IProductGet';
import SearchInput from 'components/layout/forms/SearchInput';

import configurationColumns from './configurationColumns';
import translations from '../../../../services/translations/translations';

const ConfigurationsList = (): JSX.Element => {
  const history = useHistory();
  const { t } = useTranslation([translations.products, translations.common]);

  const [configurations, setConfigurations] = useState<IProduct[]>();
  const [offset, setOffset] = useState(0);
  const [page, setPage] = useState(1);
  const [selectedRow, setSelectedRow] = useState<number>();
  const [sizePerPage, setSizePerPage] = useState(50);
  const [totalSize, setTotalSize] = useState<number>();

  const selectedConfiguration =
    configurations !== undefined && selectedRow !== undefined
      ? configurations[selectedRow]
      : undefined;
  const [searchTerms, setSearchTerms] = useState<string>('');

  useEffect(() => {
    if (selectedRow !== undefined) {
      history.push(`/products/configurations/${selectedConfiguration?.id}`);
    }
  }, [history, selectedConfiguration, selectedRow]);

  useEffect(() => {
    const getConfigurations = async () => {
      try {
        const list = await apiProducts.configurations.getAll({
          limit: sizePerPage,
          offset,
          search: searchTerms,
        });
        const count = await apiProducts.configurations.count(searchTerms);
        setConfigurations(list);
        setTotalSize(count.count);
      } catch (error) {
        // define action
      }
    };
    getConfigurations().catch((e) => console.log(e));
  }, [offset, searchTerms, sizePerPage]);

  const columns = configurationColumns(t);

  const handleTableChange = (type: any, { page, sizePerPage }: any) => {
    setPage(page);
    setSizePerPage(sizePerPage);
    setOffset((page - 1) * sizePerPage);
  };

  return (
    <>
      <Row>
        <Col xs={3}>
          <SearchInput setSearchTerms={setSearchTerms} />
        </Col>
      </Row>
      <Row>
        <Col>
          <BasicTable
            columns={columns}
            data={configurations}
            page={page}
            sizePerPage={sizePerPage}
            totalSize={totalSize}
            handleTableChange={handleTableChange}
            setSelectedRow={setSelectedRow}
            keyField="id"
          />
        </Col>
      </Row>
    </>
  );
};

export default ConfigurationsList;
